import { useCallback, useEffect, useState } from "react";

import { IB_ACTIVE_ACCOUNT_CHANGED_EVENT } from "../Constants/accountTypes";
import { EMPTY_STABLES_HISTORY_FILTERS } from "../Pages/Private/Stables/stablesHistoryFilters";

import {

  exportStablesHistory as exportStablesHistoryApi,

  getStablesHistory,

  getStablesHistoryDetail,

} from "../Services/stablesApi";



const toApiDate = (date) => {

  if (!date) return undefined;

  if (typeof date === "string") return date;

  if (date instanceof Date) return date.toISOString().slice(0, 10);

  return undefined;

};



const toApiAmount = (value) => {

  if (value === "" || value == null) return undefined;

  const normalized = String(value).replace(/\./g, "").replace(",", ".");

  const parsed = parseFloat(normalized);

  return Number.isFinite(parsed) ? parsed : undefined;

};



export const buildHistoryApiParams = ({

  type = "all",

  page = 1,

  pageSize = 10,

  filters = EMPTY_STABLES_HISTORY_FILTERS,

} = {}) => ({

  type: type === "general" ? "all" : type,

  page,

  page_size: pageSize,

  date_from: toApiDate(filters.dateFrom),

  date_to: toApiDate(filters.dateTo),

  amount_min: toApiAmount(filters.amountMin),

  amount_max: toApiAmount(filters.amountMax),

  currencies: filters.currencies,

  statuses: filters.statuses,

  payment_methods: filters.paymentMethods,

});



export const useStablesHistory = ({

  type = "all",

  page = 1,

  pageSize = 10,

  filters = EMPTY_STABLES_HISTORY_FILTERS,

  enabled = true,

} = {}) => {

  const [items, setItems] = useState([]);

  const [total, setTotal] = useState(0);

  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);



  const loadHistory = useCallback(async () => {

    if (!enabled) return;

    setLoading(true);

    setError(null);



    try {

      const result = await getStablesHistory(

        buildHistoryApiParams({ type, page, pageSize, filters })

      );

      setItems(result.items);

      setTotal(result.total);

      setTotalPages(result.totalPages);

    } catch (err) {

      setItems([]);

      setTotal(0);

      setTotalPages(1);

      setError(err);

    } finally {

      setLoading(false);

    }

  }, [enabled, filters, page, pageSize, type]);



  useEffect(() => {

    loadHistory();

  }, [loadHistory]);

  useEffect(() => {
    if (!enabled) return undefined;
    const onAccountChanged = () => {
      void loadHistory();
    };
    window.addEventListener(IB_ACTIVE_ACCOUNT_CHANGED_EVENT, onAccountChanged);
    return () => window.removeEventListener(IB_ACTIVE_ACCOUNT_CHANGED_EVENT, onAccountChanged);
  }, [enabled, loadHistory]);

  return {

    items,

    total,

    totalPages,

    loading,

    error,

    reload: loadHistory,

  };

};



export const fetchStablesHistoryDetail = (transactionId, listItem) =>
  getStablesHistoryDetail(transactionId, listItem);



export const exportStablesHistoryFromApi = (params = {}) =>

  exportStablesHistoryApi(buildHistoryApiParams(params));

